export type DayKey = "A" | "B" | "C" | "D" | "E";
export type PeriodKey = 1 | 2 | 3 | 4 | 5 | 6;
export type ClassKey = "1組" | "2組" | "3組" | "4組" | "5組" | "6組";

export const DAY_LABELS: Record<DayKey, string> = {
  A: "月曜日",
  B: "火曜日",
  C: "水曜日",
  D: "木曜日",
  E: "金曜日",
};

export const DAYS: DayKey[] = ["A", "B", "C", "D", "E"];
export const PERIODS: PeriodKey[] = [1, 2, 3, 4, 5, 6];
export const CLASSES: ClassKey[] = ["2組", "3組", "4組", "5組", "6組"];

export type TimetableData = Record<DayKey, Record<PeriodKey, string>>;
export type AllTimetables = Record<ClassKey, TimetableData>;

export const timetables: AllTimetables = {
  "1組": {
    A: { 1: "-", 2: "-", 3: "-", 4: "-", 5: "-", 6: "-" },
    B: { 1: "-", 2: "-", 3: "-", 4: "-", 5: "-", 6: "-" },
    C: { 1: "-", 2: "-", 3: "-", 4: "-", 5: "-", 6: "-" },
    D: { 1: "-", 2: "-", 3: "-", 4: "-", 5: "-", 6: "-" },
    E: { 1: "-", 2: "-", 3: "-", 4: "-", 5: "-", 6: "-" },
  },
  "2組": {
    A: { 1: "道徳", 2: "保体", 3: "数学A", 4: "社会B", 5: "国語A", 6: "英語" },
    B: { 1: "理科B", 2: "技・家", 3: "美術", 4: "AET", 5: "数学A", 6: "総合" },
    C: { 1: "英語", 2: "数学B", 3: "国語A", 4: "社会A", 5: "理科A", 6: "-" },
    D: { 1: "音楽", 2: "国語A", 3: "社会A", 4: "理科B", 5: "保体", 6: "学活" },
    E: { 1: "保体", 2: "理科A", 3: "英語", 4: "数学A", 5: "社会A", 6: "総合" },
  },
  "3組": {
    A: { 1: "道徳", 2: "保体", 3: "英語", 4: "社会A", 5: "理科A", 6: "国語A" },
    B: { 1: "社会B", 2: "数学A", 3: "理科B", 4: "英語", 5: "美術", 6: "総合" },
    C: { 1: "技・家", 2: "音楽", 3: "AET", 4: "国語A", 5: "数学A", 6: "-" },
    D: { 1: "国語A", 2: "理科B", 3: "数学B", 4: "社会A", 5: "保体", 6: "学活" },
    E: { 1: "保体", 2: "社会A", 3: "数学A", 4: "理科A", 5: "英語", 6: "総合" },
  },
  "4組": {
    A: { 1: "道徳", 2: "理科B", 3: "保体", 4: "英語", 5: "数学A", 6: "社会A" },
    B: { 1: "美術", 2: "社会A", 3: "AET", 4: "理科B", 5: "国語A", 6: "総合" },
    C: { 1: "国語A", 2: "技・家", 3: "数学A", 4: "理科A", 5: "英語", 6: "-" },
    D: { 1: "数学A", 2: "英語", 3: "音楽", 4: "保体", 5: "社会A", 6: "学活" },
    E: { 1: "数学B", 2: "保体", 3: "国語A", 4: "社会B", 5: "理科A", 6: "総合" },
  },
  "5組": {
    A: { 1: "道徳", 2: "数学A", 3: "保体", 4: "国語A", 5: "社会A", 6: "美術" },
    B: { 1: "国語A", 2: "英語", 3: "社会A", 4: "数学B", 5: "理科A", 6: "総合" },
    C: { 1: "理科B", 2: "英語", 3: "音楽", 4: "数学A", 5: "社会B", 6: "-" },
    D: { 1: "技・家", 2: "数学A", 3: "理科A", 4: "保体", 5: "英語", 6: "学活" },
    E: { 1: "理科B", 2: "保体", 3: "AET", 4: "社会A", 5: "国語A", 6: "総合" },
  },
  "6組": {
    A: { 1: "道徳", 2: "社会B", 3: "保体", 4: "数学B", 5: "美術", 6: "理科A" },
    B: { 1: "数学A", 2: "理科A", 3: "国語A", 4: "社会A", 5: "英語", 6: "総合" },
    C: { 1: "数学A", 2: "理科B", 3: "社会A", 4: "AET", 5: "音楽", 6: "-" },
    D: { 1: "英語", 2: "技・家", 3: "国語A", 4: "保体", 5: "理科B", 6: "学活" },
    E: { 1: "英語", 2: "保体", 3: "社会A", 4: "国語A", 5: "数学A", 6: "総合" },
  },
};

export const subjectColors: Record<string, string> = {
  "道徳": "bg-amber-50 text-amber-700 border-amber-200",
  "社会A": "bg-orange-50 text-orange-700 border-orange-200",
  "社会B": "bg-orange-50 text-orange-700 border-orange-200",
  "保体": "bg-green-50 text-green-700 border-green-200",
  "数学A": "bg-sky-50 text-sky-700 border-sky-200",
  "数学B": "bg-sky-50 text-sky-700 border-sky-200",
  "美術": "bg-pink-50 text-pink-700 border-pink-200",
  "理科A": "bg-teal-50 text-teal-700 border-teal-200",
  "理科B": "bg-teal-50 text-teal-700 border-teal-200",
  "国語A": "bg-red-50 text-red-700 border-red-200",
  "英語": "bg-violet-50 text-violet-700 border-violet-200",
  "AET": "bg-violet-50 text-violet-700 border-violet-200",
  "総合": "bg-gray-50 text-gray-600 border-gray-200",
  "音楽": "bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200",
  "技・家": "bg-lime-50 text-lime-700 border-lime-200",
  "学活": "bg-gray-50 text-gray-500 border-gray-200",
  "-": "bg-white text-gray-300 border-gray-100",
};
